import { useQuery } from '@tanstack/react-query';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';

/**
 * Kasowanie kategorii jest twarde i backend odrzuca je (400), gdy wiszą na niej
 * wydatki — pytamy o użycie, żeby zamiast tego zaproponować archiwizację.
 */
const useGetCostCategoryUsage = (id: string | null) => {
  return useQuery({
    queryKey: costCategoriesApiQueryKeys.usage(id ?? ''),
    queryFn: () => costCategoriesApi.getUsage(id as string),
    enabled: !!id,
  });
};

export default useGetCostCategoryUsage;
